// En pantallas angostas la navegación del evento es un <select>: al elegir, navega a la sección.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-event-nav-select]');
  if (!select) return;

  if (window.Turbo) window.Turbo.visit(select.value);
  else window.location.assign(select.value);
});
